import React from 'react';
import {RootState} from '../../app/rootReducer';
import {RouteComponentProps} from 'react-router';
import {uploadedFilesRoute, UploadedFilesRoute} from '../../app/appRoutes';
import {push} from 'connected-react-router';
import {connect, ConnectedProps} from 'react-redux';
import ImageModal from '../imageList/imageModal/ImageModal';
import {UploadedFileTypeEnum} from '../../interfaces/models';
import {SaveImageDataDto} from '../../interfaces/dto';
import {saveUploadedImageData} from './fileUploadSlice';

type Props = ConnectedProps<typeof connector>;

class FileUploadImageModalContainer extends React.Component<Props> {
    getFile() {
        const {match: {params}, uploadedFiles} = this.props;
        const fileId = params.fileId ? parseInt(params.fileId) : undefined;
        return fileId !== undefined ? uploadedFiles?.find(x => x.id === fileId) : undefined;
    }
    
    render() {
        const {match: {params}, push, uploadedFiles, pageCount, isLoading, saveUploadedImageData} = this.props;
        const file = this.getFile();
        const image = file?.imageData;
        if (!file || !image) return null;
        
        const closeModal = () => {
            push(uploadedFilesRoute(params.page));
        };
        
        const navigateToNextImage = () => {
            const idx = uploadedFiles.indexOf(file);
            if (idx < 0 || idx === uploadedFiles.length - 1)
                return closeModal();

            const page = +params.page;
            
            const nextImage = uploadedFiles.slice(idx + 1).find(x => x.fileType === UploadedFileTypeEnum.Image);
            if (nextImage) {
                push(uploadedFilesRoute(page, nextImage.id));
                document.getElementsByClassName("modal")[0].scrollTop = 0;
            }
            else {
                if (page < pageCount) {
                    return push(uploadedFilesRoute(page + 1));
                } else {
                    return closeModal();
                }
                
            }
        }
        
        const handleSave = (next: boolean, dto: SaveImageDataDto) => {
            saveUploadedImageData(dto);
            next ? navigateToNextImage() : closeModal();
        }
        
        return <ImageModal isLoading={isLoading} 
                           image={image} 
                           closeModal={closeModal} 
                           navigateToNextImage={navigateToNextImage} 
                           handleSave={handleSave} />
    }
}



const mapStateToProps = (state: RootState, ownProps: RouteComponentProps<UploadedFilesRoute>) => {
    return {
        ...state.uploads,
        isLoading: state.api.isLoading,
        ...ownProps
    }
};
const mapDispatchToProps = {push, saveUploadedImageData};
const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(FileUploadImageModalContainer);